export default function (name) {
    const names = name.toString().toUpperCase().split(" ");
    let initials = names[0][0];
    if (names[1]) {
        initials = initials + names[1][0];
    }
    return initials;
}
